import { useNavigate } from 'react-router-dom';
import { Loader } from '../../../component/loader';
import {
  Table,
  TableBody,
  TableData,
  TableHead,
  TableRow,
  TH
} from '../../../component/table';
import { useGetAllLifestyleAgentQuery } from '../../../store/lifeStyle/api';
import {
  ActionBtn,
  AgentAvatar,
  AgentContainer,
  AgentName,
  Container,
  Header,
  StatusContainer,
  Title
} from './style';

export const Users = () => {
  const navigate = useNavigate();
  const { data: allLifestyleAgent, isLoading } = useGetAllLifestyleAgentQuery();
  return (
    <Container>
      {isLoading && <Loader />}
      <Header>
        <Title>Verification requests</Title>
      </Header>
      <Table>
        <TableHead>
          <TableRow>
            <TH>S/N</TH>
            <TH>Agent</TH>
            <TH>Category</TH>
            <TH>Verification type</TH>
            <TH>Date</TH>
            <TH>Status</TH>
            <TH>Action</TH>
          </TableRow>
        </TableHead>
        <TableBody>
          {allLifestyleAgent?.data.fetchedData.map((user, index) => (
            <TableRow key={user._id}>
              <TableData>{++index}</TableData>
              <TableData>
                <AgentContainer>
                  <AgentAvatar alt="" src={user.avatar.url} />
                  <div>
                    <AgentName>{`${user.firstname} ${user.lastname}`}</AgentName>
                    <p>Lifestyle agent</p>
                  </div>
                </AgentContainer>
              </TableData>
              <TableData>{user.category?.title || 'N/A'}</TableData>
              <TableData>{user.personalDocument.type || 'N/A'}</TableData>
              <TableData>{new Date(user.createdAt).toDateString()}</TableData>
              <TableData>
                <StatusContainer status={user.adminVerified}>
                  {user.adminVerified ? 'VERIFIED' : 'NOT VERIFIED'}
                </StatusContainer>
              </TableData>
              <TableData>
                <ActionBtn
                  onClick={() =>
                    navigate(`view/${user._id}#profile`, { state: user })
                  }
                >
                  View
                </ActionBtn>
              </TableData>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Container>
  );
};
